import { render } from "./GdprLogs.vue?vue&type=template&id=59226ccf&scoped=true"
import script from "./GdprLogs.vue?vue&type=script&lang=ts"
export * from "./GdprLogs.vue?vue&type=script&lang=ts"

import "./GdprLogs.vue?vue&type=style&index=0&id=59226ccf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59226ccf"

export default script